/**
 * Request a signed payload token from the backend for use with X-Payload-Token header.
 * @param {object} http - Axios instance (e.g. this.$http)
 * @param {string} action - Action name (e.g. 'listDivisions', 'getUser')
 * @param {object} payload - Payload object to sign (must match backend expected shape)
 * @param {number|string} [resourceId] - Optional resource id for by-id operations
 * @returns {Promise<string>} The token to set in X-Payload-Token header
 */
export async function getPayloadToken(http, action, payload, resourceId) {
  const body = { action, payload }
  if (resourceId !== undefined && resourceId !== null) {
    body.resourceId = resourceId
  }
  const res = await http.post('/api/payload/sign', body)
  return res.data.token
}

export default getPayloadToken
